import { render, staticRenderFns } from "./wizardUploadMaterial.vue?vue&type=template&id=089f901c&scoped=true"
import script from "./wizardUploadMaterial.vue?vue&type=script&lang=js"
export * from "./wizardUploadMaterial.vue?vue&type=script&lang=js"
import style0 from "./wizardUploadMaterial.vue?vue&type=style&index=0&id=089f901c&prod&scoped=true&lang=css"
import style1 from "./wizardUploadMaterial.vue?vue&type=style&index=1&id=089f901c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089f901c",
  null
  
)

export default component.exports